import { DocumentType } from '../../product-card/interfaces/product-card.interface';
import { ProductCardData } from '../../product-card/product-card-display';

/**
 * Maps the product data to an array of string values based on the provided field names.
 *
 * @param products
 * @param fields
 */
export function mapProductsToArray(
  products: ProductCardData[],
  fields: string[]
): string[][] {
  return products.map(product => {
    const result: string[] = [];

    for (const field of fields) {

      if(product.documentType === DocumentType.products && field === 'programId') {
        result.push('');
        continue;
      }

      if(product.documentType === DocumentType.programs && ['mhid', 'isbn13', 'netPrice'].includes(field)) {
        result.push('');
        continue;
      }

      if (
        !Object.prototype.hasOwnProperty.call(product, field)
        || !['string', 'number', 'boolean', 'undefined'].includes(typeof product[field])
      ) {
        result.push('');
        continue;
      }

      result.push(String(product[field] ?? ''));
    }

    return result;
  });
}
